interface IPersist {
  purge(): any;
  rehydrate(): any;
}

class PersistService<T extends IPersist> {
  persist!: T;

  async rehydrateSafe() {
    try {
      await this.persist.rehydrate();
    } catch (error) {
      await this.persist.purge();
    }
  }
}

export default new PersistService();
